import Footer from '../Contact'

export function About() {
    return (
        <section id="about">
        <Footer />
        </section>
    )
}

